import React from "react";

const SkeletonConstant = ({ width, height, additional }) => {
  return <div className={`bg-skeleton ${width} ${height} ${additional}`}></div>;
};

export default SkeletonConstant;